// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { secondsToMinutes as fn } from "../secondsToMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const secondsToMinutes = convertToFP(fn, 1);

// Fallback for modularized imports:
export default secondsToMinutes;
